import { actionCreator } from '@bit/wavfichacerta.fichacerta.utils.redux-utils';
import { OPEN_MENU_ITEM, CLOSE_MENU_ITEM, RETRACT_MENU } from './types';

export const activeMenu = payload => actionCreator(OPEN_MENU_ITEM, payload);
export const closeMenu = payload => actionCreator(CLOSE_MENU_ITEM, payload);
export const retractMenu = () => actionCreator(RETRACT_MENU)